module.exports = __webpack_public_path__ + "static/media/DummyContract.53c7ec72.png";